module.exports = __webpack_public_path__ + "img/percent-icon.e985115b.svg";